import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, align = "center" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-16`}>
    <Reveal>
      <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-gold mb-4">{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-heading font-black uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tight">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-zinc-400 text-base sm:text-lg leading-relaxed">{sub}</p>
      </Reveal>
    )}
    <Reveal delay={0.2}>
      <div className={`mt-7 h-[3px] w-16 bg-gold ${align === "center" ? "mx-auto" : ""}`} />
    </Reveal>
  </div>
);
